import { Routes } from "@angular/router";

const loadLandingPage = () =>
	import("./landing/landing.page").then((m) => m.LandingPage);

export const routes: Routes = [
	{
		path: "",
		loadComponent: loadLandingPage,
		data: { page: "home" },
	},
	{
		path: "products",
		loadComponent: loadLandingPage,
		data: { page: "products" },
	},
	{
		path: "support",
		loadComponent: loadLandingPage,
		data: { page: "support" },
	},
	{
		path: "privacy",
		loadComponent: loadLandingPage,
		data: { page: "privacy" },
	},
	{
		path: "terms",
		loadComponent: loadLandingPage,
		data: { page: "terms" },
	},
	{
		path: "landing",
		redirectTo: "",
		pathMatch: "full",
	},
	{
		path: "**",
		redirectTo: "",
	},
];
